<div class="content-box-wrapper">
	<div class="content-box form-wrapper">
		<div class="auth-content">
			<h2 class="align-center section-heading" [translate]="'registration.code-verification.title'">
				Thank You, {{ name }}
			</h2>
			<p class="align-center" [translate]="'registration.code-verification.description'" *ngIf="!codeResent">
				A 6-digit verification code was just sent to {{ email }}. Please enter it below.
			</p>
			<p class="align-center" *ngIf="codeResent">We have emailed you a new verification code. Please enter it below.</p>
		</div>
		<form [formGroup]="verifyAccountForm">
			<div class="row">
				<div class="col-md-12">
					<div class="row justify-content-md-center">
						<div class="col-12">
							<mat-form-field class="form-group">
								<mat-label>{{ 'registration.code-verification.form.verification-code' | translate }}</mat-label>
								<input matInput formControlName="verificationCode" appNumbersOnly maxlength="6" />
								<mat-hint *ngIf="codeInvalid">
									<span class="error-color" [translate]="'registration.code-verification.code-invalid'"></span>
								</mat-hint>
								<mat-error>
									<app-error-message [control]="'verificationCode'"></app-error-message>
								</mat-error>
							</mat-form-field>
						</div>
					</div>
				</div>
			</div>
		</form>
		<div class="row justify-content-md-center">
			<div class="col-md-12">
				<div class="center">
					<button class="button" mat-button appEheAnalytics [data]="analyticsData" (click)="verifyCode()">
						<span [translate]="'registration.code-verification.form.submit-button'">SUBMIT CODE</span>
					</button>
				</div>
			</div>
		</div>
		<div class="row resend-container">
			<div class="col-12">
				<div class="center">
					<p class="align-center text" [translate]="'registration.code-verification.havent-received-code'">
						Haven't received your code?
					</p>
					<p
						class="align-center center link"
						(click)="resendVerificationCode()"
						appEheAnalytics
						[data]="analyticsData"
						[translate]="'registration.code-verification.resend-code'">
						Resend code
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
